<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Please Confirm</h1>
        </template>
        
        <p>All future emails from them will resume showing up in your Daily Digest. Confirm?</p>

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Confirming..."
                @click.native="submit"
            >
                Yes, remove review.
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data: () => {
        return  {
            loading: false,
        }
    },
    methods: {
        submit() {
            this.loading = true;
            axios.delete('/api/intents/' + this.id)
            .then(response => {
                this.$emit('resolve');
            })
            .catch(err => {
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>